import React, { useEffect, useState } from "react";
import UsersUi from "./UsersUi";
import Layout from "../../Components/Layout/Layout";
import { useNavigate } from "react-router-dom";
import {
  useDeleteUserMutation,
  useEditUserMutation,
  useGetUsersQuery,
} from "../../store/Api/users";
import { hidetoast, useDecodeToken } from "../../Utils/function";
import { useGetRrbQuery } from "../../store/Api/common";
import { hideToast } from "../../store/toastSlice";
import { useDispatch, useSelector } from "react-redux";
import  {rowsPerPage} from '../../Utils/constant'

function Users() {
  const navigate = useNavigate();
  const [deleteUser] = useDeleteUserMutation();
  const [updateUserStatus] = useEditUserMutation();
  const [deleteId, setDeleteId] = useState("");
  const [toastMsg,setToastMsg] = useState("");
  const [toastType, setToastType] = useState("");
  const decodedToken = useDecodeToken();
  const [tableQaury, setTableQaury] = useState({
    search: "",
    rowsPerPage:rowsPerPage,
    currentPage: 1,
    rrbId: decodedToken?.role == 1 ? `${decodedToken?.rrb_id}` : "",
  });
  const { data: rrb } = useGetRrbQuery({});
  const [filtersId, setFiltersId] = useState({
    rrbId: decodedToken?.role == 1 ? `${decodedToken?.rrb_id}` : "",

  });
  const [selectData, setSelectData] = useState({
    rrb: [],
  });
  const { data, isFetching, isLoading, refetch } = useGetUsersQuery({
    search: tableQaury.search,
    limit: tableQaury.rowsPerPage,
    page: tableQaury.currentPage,
    rrb_id: filtersId?.rrbId,
  });
  const dispatch = useDispatch();
  const toast = useSelector((state) => state.toast);

  // Auto-hide toast after 3 seconds
 useEffect(() => {
    if (toast.message) {
       hidetoast()
      // const timer = setTimeout(() => {
      //   dispatch(hideToast());
      // }, 3000);
      // return () => clearTimeout(timer);
    }
  }, [toast.message, dispatch]);
  useEffect(() => {
    if (filtersId?.rrbId) {
      refetch();
    }
  }, [filtersId]);
  useEffect(() => {
    setSelectData({
      rrb: rrb?.data?.data,
    });
  }, [rrb]);
  const onUpdate = async (userId, status) => {
    const newstatus = {
      status: status,
    };
    // navigate(`/update-user/${adminData}`, { state: { adminData } });
    try {
      const response = await updateUserStatus({
        id: userId,
        status: newstatus,
      });
      if (response?.data?.success) {
        refetch(); // Refresh the user list after updating
      }
    } catch (error) {
      console.error(error, "Error updating user status");
    }
  };
  const onUpdateUser = (row) => {
    const data = row;
    navigate(`/update-auditor`, { state: { data } });
  };
  const deleteAdminFn = async () => {
    try {
      const response = await deleteUser({ id: deleteId });
    
      if (response?.data?.success) {
        refetch();
        // navigate("/otp", { state: { phoneNumber: values?.phoneNumber } });
      } 
    } catch (error) {
      console.log(error, "verify otp error");
    }
  };
  const handlePageChange = (newPage) => {
    setTableQaury({ ...tableQaury, currentPage: newPage });
  };
  const columns = [
    { title: "First Name", dataKey: "firstname" },
    { title: "Last Name", dataKey: "lastname" },
    { title: "Designation", dataKey: "designation" },
    { title: "Phone Number", dataKey: "phone_number" },
    ...(decodedToken?.role === 3 || decodedToken?.role === 4
      ? [{ title: "RRB", dataKey: "rrb", isObject: true, objectKey: "name" }]
      : []),
    {
      title: "Actions",
      render: (_, row) => (
        <div className="d-flex align-items-center">
          <div className="form-group mb-0">
            <div className="custom-control custom-switch">
              <input
                type="checkbox"
                className="custom-control-input"
                id={`userStatusSwitch-${row.id}`}
                checked={row.status}
                onChange={(e) => onUpdate(row.id, e.target.checked)}
              />
              <label
                className="custom-control-label"
                htmlFor={`userStatusSwitch-${row.id}`}
              ></label>
            </div>
          </div>
          <button
            className="border-0 bg-transparent"
            type="button"
            onClick={() => onUpdateUser(row)}
          >
            <i className="fas fa-edit text-success"> </i>
          </button>
          <button
            className="border-0 bg-transparent"
            type="button"
            onClick={() => setDeleteId(row.id)}
            data-toggle="modal"
            data-target="#modal-danger"
          >
            <i className="fas fa-trash text-danger"></i>
          </button>
        </div>
      ),
    },
  ];
  const removeFilter = () => {
    setFiltersId({
      rrbId: decodedToken?.role == 1 ? `${decodedToken?.rrb_id}` : "",
    });
    refetch();
    setSelectData({
      rrb: rrb?.data?.data,
    });
  };
  const handleAddAuditor = () => {
    navigate("/create-auditor")
  }
  
  return (
    <Layout>
      <UsersUi
        columns={columns}
        data={data?.data?.users || []}
        tableQaury={tableQaury}
        onPageChange={handlePageChange}
        totalRecords={data?.data?.totalItems} // Assuming the API returns a total count
        loading={isLoading}
        deleteAdminFn={deleteAdminFn}
        setTableQaury={setTableQaury}
        selectData={selectData}
        setFiltersId={setFiltersId}
        setSelectData={setSelectData}
        filtersId={filtersId}
        removeFilter={removeFilter}
        decodedToken={decodedToken}
        toast={toast}
        handleAddAuditor={handleAddAuditor}
      />
    </Layout>
  );
}

export default Users;
